module.exports = __webpack_public_path__ + "img/bnr_special_01sp.fa2ebe78.jpg";